<template>
  <div class="ct-split">
    <aside class="ct-nav">
      <editor-section-nav
        :sections="sections"
        :active-section="activeSection"
        @navigate="setSection"
      />
    </aside>

    <div class="ct-content">
      <!-- General settings -->
      <div v-if="activeSection === 'general'">
      <!-- Header settings -->
      <collapsible-section title="Header">
        <template #icon>
          <b-icon icon="card-heading" class="collapsible-section__icon" />
        </template>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <label>Title</label>
            <base-input type="text" placeholder="Enter some text" v-model="selectedBss.title"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <label>Subtext</label>
            <base-input type="text" placeholder="Enter some text" v-model="selectedBss.subtext"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.display_progress_bar"  />
            <label> &nbsp; Display progress bar</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_language_switcher"  />
            <label> &nbsp; Display language switcher</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.display_section_titles"  />
            <label> &nbsp; Display progress bar section titles</label>
          </div>
        </div>
      </collapsible-section>

      <!-- Colors and typography -->
      <collapsible-section title="Colors and typography" icon="tim-icons icon-palette" :default-open="false">
        <div class="color-palette">
          <section class="color-palette__group">
            <header class="color-palette__group-head">
              <span class="color-palette__eyebrow">Page</span>
            </header>
            <div class="color-palette__fields">
              <color-field v-model="selectedBss.background_color" label="Background" />
              <color-field v-model="selectedBss.text_color" label="Text" />
            </div>
          </section>

          <section class="color-palette__group">
            <header class="color-palette__group-head">
              <span class="color-palette__eyebrow">Cards</span>
            </header>
            <div class="color-palette__fields">
              <color-field v-model="selectedBss.card_color" label="Card background" />
              <color-field v-model="selectedBss.text_color_card" label="Card text" />
              <color-field v-model="selectedBss.link_color" label="Links" />
              <color-field v-model="selectedBss.button_color" label="Buttons" />
              <color-field v-model="selectedBss.input_border_color" label="Input border" />
            </div>
          </section>

          <section class="color-palette__group">
            <header class="color-palette__group-head">
              <span class="color-palette__eyebrow">Typography</span>
            </header>
            <div class="color-palette__fields">
              <base-input label="Page font">
                <el-select
                  v-model="selectedBss.font_family"
                  class="select-primary"
                  :style="{'font-family': selectedBss.font_family}"
                  name="font"
                  placeholder="Font"
                >
                  <el-option
                    v-for="(f, i) in orderedFonts" :key="'B' + i"
                    :style="{'font-family': f.family}"
                    class="select-primary"
                    :label="f.family"
                    :value="f.family"
                  >
                  </el-option>
                </el-select>
              </base-input>
              <base-input label="Card font">
                <el-select
                  v-model="selectedBss.font_family_card"
                  class="select-primary"
                  :style="{'font-family': selectedBss.font_family_card}"
                  name="font"
                  placeholder="Font"
                >
                  <el-option
                    v-for="(f, i) in orderedFonts" :key="'C' + i"
                    :style="{'font-family': f.family}"
                    class="select-primary"
                    :label="f.family"
                    :value="f.family"
                  >
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </section>
        </div>
        <div class="color-palette__footer">
          <a href="#" class="color-palette__reset" @click.prevent="resetPaletteColors">
            <i class="tim-icons icon-refresh-01"></i>
            Reset to defaults
          </a>
        </div>
      </collapsible-section>

      <!-- Logo -->
      <collapsible-section title="Logo" icon="tim-icons icon-image-02" :default-open="false">
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_logo"  />
            <label> &nbsp; Show logo on booking site</label>
          </div>
        </div>
        <div class="row mt-3" v-if="selectedBss.show_logo">
          <div class="col-lg-2 col-3">
            <base-input v-model.number="selectedBss.logo_height" label="Logo height"></base-input>
          </div>
          <div class="col-lg-2 col-3">
            <base-input v-model.number="selectedBss.logo_width" label="Logo width"></base-input>
          </div>
          <div class="col-lg-3 col-4">
            <base-input label="Logo fit">
              <el-select
                v-model="selectedBss.logo_fit"
                class="select-primary"
              >
                <el-option
                  v-for="option in fitOptions"
                  class="select-primary"
                  :label="option"
                  :value="option"
                  :key="option"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="selectedBss.show_logo && selectedBss.logo">
          <div class="col">
            <div>
              <img :height="selectedBss.logo_height" :width="selectedBss.logo_width" :style="{'object-fit': selectedBss.logo_fit}" :src="selectedBss.logo" alt="preview" />
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_logo">
          <div class="col-md-12 col-lg-12 col-sm-12 col-12">
            <span class="btn btn-primary btn-sm btn-simple btn-file">Upload
              <input
                accept="image/*"
                @change="$emit('handle-preview', $event)"
                type="file"
                name="..."
                class="valid"
                :multiple="false"
                aria-invalid="false"
              />
            </span>
          </div>
        </div>
      </collapsible-section>

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>

    <!-- Event selection -->
    <div v-if="activeSection === 'events'">
      <!-- Layout type picker -->
      <collapsible-section title="Layout">
        <template #icon>
          <b-icon icon="layout-three-columns" class="collapsible-section__icon" />
        </template>
        <div class="layout-picker">
          <div
            v-for="lt in layoutTypes"
            :key="'lt-' + lt.id"
            class="layout-option"
            :class="{ active: selectedBss.layout_type_id === lt.id }"
            @click="selectedBss.layout_type_id = lt.id"
          >
            <div class="layout-option__preview" :class="'layout-preview-' + lt.name">
              <template v-if="lt.name === 'cards'">
                <div class="mini-card"></div>
                <div class="mini-card"></div>
                <div class="mini-card"></div>
              </template>
              <template v-if="lt.name === 'list'">
                <div class="mini-row"></div>
                <div class="mini-row"></div>
                <div class="mini-row"></div>
              </template>
              <template v-if="lt.name === 'calendar'">
                <div v-for="n in 28" :key="'mc-' + n" class="mini-cal-cell"></div>
              </template>
            </div>
            <span class="layout-option__label">{{ lt.label }}</span>
          </div>
        </div>
        <info-hint v-if="selectedBss.layout_type_id === 3" style="width: 100%" class="mt-3">Calendar view shows each event's availability as a month calendar. Choosing it <strong>merges date and time selection into a single step</strong>, so customers pick a day and then a time all in one place.</info-hint>
        <div v-if="selectedBss.layout_type_id === 2" class="mt-3">
          <label class="image-size-label">Image size</label>
          <div class="image-size-picker">
            <div
              v-for="size in listImageSizes"
              :key="'lis-' + size.id"
              class="image-size-option"
              :class="{ active: selectedBss.list_image_size === size.id }"
              @click="selectedBss.list_image_size = size.id"
            >
              <div class="image-size-option__preview">
                <div class="size-thumb" :style="{ width: size.thumbWidth + 'px', height: size.thumbHeight + 'px' }"></div>
                <div class="size-lines">
                  <div class="size-line"></div>
                  <div class="size-line short"></div>
                </div>
              </div>
              <span class="layout-option__label">{{ size.label }}</span>
            </div>
          </div>
          <label class="image-size-label mt-3">Image position</label>
          <div class="image-size-picker">
            <div
              v-for="pos in listImagePositions"
              :key="'lip-' + pos.id"
              class="image-size-option"
              :class="{ active: selectedBss.list_image_position === pos.id }"
              @click="selectedBss.list_image_position = pos.id"
            >
              <div v-if="pos.id === 3" class="image-size-option__preview" style="flex-direction: row; align-items: stretch;">
                <div style="display: flex; flex-direction: column; gap: 2px;">
                  <div class="size-thumb" style="width: 14px; height: 10px;"></div>
                  <div class="size-line" style="width: 14px;"></div>
                </div>
                <div class="size-lines">
                  <div class="size-line"></div>
                  <div class="size-line short"></div>
                </div>
              </div>
              <div v-else class="image-size-option__preview" :style="{ flexDirection: pos.id === 1 ? 'row' : 'row-reverse' }">
                <div class="size-thumb" :style="{ width: '14px', height: '18px' }"></div>
                <div class="size-lines">
                  <div class="size-line"></div>
                  <div class="size-line short"></div>
                </div>
              </div>
              <span class="layout-option__label">{{ pos.label }}</span>
            </div>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Events" icon="tim-icons icon-calendar-60">
        <!-- Add event -->
        <div class="row mb-3" v-if="availableGames.length > 0">
          <div class="col-md-6 col-12">
            <el-select
              class="add-btn-select"
              placeholder="+ Add event"
              @change="addGame($event)"
              value=""
              size="small"
            >
              <el-option
                v-for="game in availableGames"
                :key="'AG' + game.id"
                :label="game.name"
                :value="game"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- Active games table -->
        <table class='table'>
          <thead>
          <tr>
            <th scope='col'></th>
            <th scope='col'>Event</th>
            <th scope='col'>Actions</th>
          </tr>
          </thead>
          <draggable v-model="sortableGames" tag="tbody" @end="onDragEnd">
          <tr v-for='item in sortableGames' :key="'G' + item.game_id">
            <td scope='row'>
              <i style="cursor: move" class="tim-icons el-icon-rank"></i>
            </td>
            <td scope='row'>
              <div class="row">
                <div class="col">
                  <p>{{item.name}}</p>
                </div>
              </div>
            </td>
            <td scope='row'>
              <base-button link type="danger" size="sm" @click="removeGame(item)">
                <i class="tim-icons icon-simple-remove"></i>
              </base-button>
            </td>
          </tr>
          </draggable>
          <tbody>
            <tr>
              <td scope='row'></td>
              <td scope='row'>
                <div class="row">
                  <div class="col">
                    <p>Gift cards</p>
                  </div>
                </div>
              </td>
              <td scope='row'>
                <el-switch active-color="#e14eca"
                           v-model="selectedBss.gift_cards_enabled" />
              </td>
            </tr>
          </tbody>
        </table>

      </collapsible-section>

      <collapsible-section title="Event display" :default-open="false">
        <template #icon>
          <b-icon icon="card-text" class="collapsible-section__icon" />
        </template>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.allow_autoscroll"  />
            <label>Auto rotate images</label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_game_title"  />
            <label>Show event title</label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_number_of_players"  />
            <label>Show number of players</label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_game_difficulty"  />
            <label>Show event ratings
              <el-popover trigger="hover" placement="right" width="320">
                <div>
                  <div class="popover-body" style="word-break: normal; text-align: left;">Shows each event's ratings, such as difficulty, on this booking site. A rating appears when its <strong>Show to customers</strong> switch is on in the event's settings. Rating scales are managed under Event settings, on the Ratings tab.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_game_duration"  />
            <label>Show event duration</label>
          </div>
        </div>
        <div class="row mt-1" v-if="selectedBss.layout_type_id === 1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_game_details_over_image"  />
            <label>Display informational fields on top of event image</label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_game_description"  />
            <label>Show event description before time selection
              <el-popover trigger="hover" placement="right" width="320">
                <div>
                  <div class="popover-body" style="word-break: normal; text-align: left;">Adds a <strong>learn more</strong> trigger to each event so players can read the event description before choosing a time. On the cards layout the description appears over the event image, and on the list layout it expands below the event details. Events without a description will not show the trigger.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div v-if="selectedBss.show_game_description" class="game-info-trigger-config">
          <div class="row">
            <div class="col-lg-4 col-md-6">
              <label class="d-block">Trigger style</label>
              <segmented-toggle variant="pills" size="sm"
                                v-model="selectedBss.game_info_trigger_type"
                                :options="[{ value: 'icon', label: 'Icon' }, { value: 'text', label: 'Custom text' }]" />
            </div>
            <div class="col-lg-4 col-md-6" v-if="selectedBss.game_info_trigger_type === 'icon'">
              <base-input label="Trigger icon">
                <el-select v-model="selectedBss.game_info_trigger_icon"
                           class="select-primary"
                           filterable>
                  <el-option v-for="(icon, index) in triggerIconOptions"
                             class="select-primary"
                             :label="icon.name"
                             :value="icon.value"
                             :key="'GIT' + index">
                    <span style="float: left; display: flex; align-items: center;">
                      <b-icon :icon="icon.value" scale="1" class="mr-1" color="#e14eca"></b-icon>
                      {{ icon.name }}
                    </span>
                  </el-option>
                </el-select>
              </base-input>
            </div>
            <div class="col-lg-4 col-md-6" v-if="selectedBss.game_info_trigger_type === 'text'">
              <base-input label="Trigger text">
                <el-input v-model="selectedBss.game_info_trigger_text"
                          :maxlength="30"
                          show-word-limit
                          placeholder="Learn more"></el-input>
              </base-input>
            </div>
          </div>
          <div class="row mt-2" v-if="selectedBss.layout_type_id === 1">
            <div class="col">
              <label class="d-block">Location</label>
              <segmented-toggle variant="pills" size="sm"
                                v-model="selectedBss.game_info_trigger_position"
                                :options="triggerPositionOptions" />
            </div>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Availability" icon="tim-icons icon-refresh-02" :default-open="false">
        <div class="row">
          <div class="col-lg-4 col-md-6 col-12">
            <label>
              <div>Default calendar date
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">Set which date the booking site calendar <br/>
                      should display by default when customers <br/>
                      first load the page.</div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input>
              <el-select
                v-model="selectedBss.default_date_type"
                class="select-primary"
                value-key="id"
                placeholder="Select default date">
                <el-option
                  v-for="(option, index) in defaultDateOptions"
                  class="select-primary"
                  :label="option.label"
                  :value="{id: option.id, label: option.label}"
                  :key="'DDO' + index"
                ></el-option>
              </el-select>
            </base-input>
          </div>
          <div class="col-lg-3 col-md-4 col-6" v-if="selectedBss.default_date_type && selectedBss.default_date_type.id === 1">
            <base-input label="Days ahead">
              <el-input-number style="width: 100%" v-model="selectedBss.default_days_ahead" :min="1" :max="365"/>
            </base-input>
          </div>
          <div class="col-lg-4 col-md-5 col-6" v-if="selectedBss.default_date_type && selectedBss.default_date_type.id === 2">
            <base-input label="Specific date" :error="errs.default_specific_date">
              <el-date-picker
                style="width: 100%"
                v-model="selectedBss.default_specific_date"
                type="date"
                placeholder="Select date"
                :format="dateFormatCal"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.hide_date_selection"  />
            <label>Hide date selection
              <el-popover trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, the date picker and navigation <br/>
                    arrows are hidden. The page auto-refreshes at <br/>
                    midnight to roll the date forward. <br/>
                    Ideal for displaying on a TV.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-1" v-if="selectedBss.layout_type_id !== 3">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_calendar_link"  />
            <label>Show link to calendar view</label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.enable_real_time_updates" />
            <label>Update availability in real time
              <el-popover trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, the booking site will <br/>
                    automatically update availability in <br/>
                    real-time without requiring a page refresh.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_booking_notice_countdown"  />
            <label>Show booking deadline countdown
              <el-popover trigger="hover" placement="right" width="260">
                <div>
                  <div class="popover-body" style="word-break: normal; text-align: left">When a customer is booking a slot that is close to its minimum booking notice cutoff, a banner with a live countdown encourages them to finish before the slot becomes unavailable.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_booking_notice_countdown">
          <div class="col-md-4 col-6">
            <label>Countdown window (minutes)</label>
            <el-input-number style="width: 100%" v-model="selectedBss.booking_notice_countdown_minutes" :min="1" :max="1440"/>
          </div>
        </div>
        <info-hint v-if="selectedBss.show_booking_notice_countdown" style="width: 100%" class="mt-2">The countdown only appears once a slot is within this many minutes of closing. A larger window warns customers earlier, a smaller one keeps the banner from showing on every booking.</info-hint>
      </collapsible-section>

      <collapsible-section title="Time slots" icon="tim-icons icon-time-alarm" :default-open="false">
        <div class="row">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_available_ticket_count"  />
            <label>Show available ticket count
              <el-popover trigger="hover" placement="right">
                <div>
                  <div class="popover-body">Applies to public bookings only.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_unavailable_slots"  />
            <label>Show sold out and blocked slots</label>
          </div>
        </div>
        <div class="row mt-1" v-if="selectedBss.show_unavailable_slots">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.hide_custom_message_when_sold_out"  />
            <label>Hide custom messages on sold out slots
              <el-popover trigger="hover" placement="right">
                <div>
                  <div class="popover-body">When enabled, any custom message added <br/>
                    to an individual slot is hidden once that <br/>
                    slot is sold out. Prevents promotional <br/>
                    badges (like Last Slot!) from showing <br/>
                    alongside a sold out state.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-1">
          <div class="col switch-row">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.allow_request_to_book" />
            <label>Show request to book slots
              <el-popover trigger="hover" placement="right" width="260">
                <div>
                  <div class="popover-body" style="word-break: normal; text-align: left">Requestable slots let customers submit a booking request for staff approval instead of booking instantly. Slots become requestable through their status or a schedule's minimum notice setting. When hidden, requestable slots display the same way as blocked slots. Payment handling for requests is configured under payment settings.</div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>

        <label class="mt-3">Slot appearance</label>
        <info-hint style="width: 100%">
          Background and text colors apply to the calendar view.
        </info-hint>
        <div class="row">
          <div class="col-lg-10">
            <table class='table'>
              <thead>
              <tr>
                <th scope='col'>Booking slot status</th>
                <th scope='col'>Slot text</th>
                <th scope='col'>Background color</th>
                <th scope='col'>Text color</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td scope='row'>Available</td>
                <td scope='row'><span class="text-muted">None</span></td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.available_slot_background_color" show-alpha></el-color-picker>
                  <div v-if="errs.available_slot_background_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.available_slot_background_color }}</div>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.available_slot_text_color" show-alpha></el-color-picker>
                  <div v-if="errs.available_slot_text_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.available_slot_text_color }}</div>
                </td>
              </tr>
              <tr>
                <td scope='row'>Sold out</td>
                <td scope='row'>
                  <base-input class="mb-0" v-model="selectedBss.booked_text" placeholder="Sold out"></base-input>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.sold_out_slot_background_color" show-alpha></el-color-picker>
                  <div v-if="errs.sold_out_slot_background_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.sold_out_slot_background_color }}</div>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.sold_out_slot_text_color" show-alpha></el-color-picker>
                  <div v-if="errs.sold_out_slot_text_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.sold_out_slot_text_color }}</div>
                </td>
              </tr>
              <tr>
                <td scope='row'>Blocked</td>
                <td scope='row'>
                  <base-input class="mb-0" v-model="selectedBss.blocked_text" placeholder="Blocked"></base-input>
                </td>
                <td scope='row'><span class="text-muted">Uses sold out colors</span></td>
                <td scope='row'><span class="text-muted">Uses sold out colors</span></td>
              </tr>
              <tr>
                <td scope='row'>Call to book</td>
                <td scope='row'>
                  <base-input class="mb-0" v-model="selectedBss.call_to_book_text" placeholder="Call to book"></base-input>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.ctb_slot_background_color" show-alpha></el-color-picker>
                  <div v-if="errs.ctb_slot_background_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.ctb_slot_background_color }}</div>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.ctb_slot_text_color" show-alpha></el-color-picker>
                  <div v-if="errs.ctb_slot_text_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.ctb_slot_text_color }}</div>
                </td>
              </tr>
              <tr>
                <td scope='row'>Request to book</td>
                <td scope='row'>
                  <base-input class="mb-0" v-model="selectedBss.request_to_book_text" placeholder="Request to book" :maxlength="200"></base-input>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.rtb_slot_background_color" show-alpha></el-color-picker>
                  <div v-if="errs.rtb_slot_background_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.rtb_slot_background_color }}</div>
                </td>
                <td scope='row'>
                  <el-color-picker v-model="selectedBss.rtb_slot_text_color" show-alpha></el-color-picker>
                  <div v-if="errs.rtb_slot_text_color" class="text-danger" style="font-size: 0.75rem;">{{ errs.rtb_slot_text_color }}</div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </collapsible-section>

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>

    <!-- Event details -->
    <div v-if="activeSection === 'event-details'">
      <collapsible-section title="Pricing" icon="tim-icons icon-money-coins">
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_total_pricing_on_events"  />
            <label> &nbsp; Show event pricing with taxes and fees included</label>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Add ons" icon="tim-icons icon-bag-16" :default-open="false">
        <info-hint class="mt-0">Shown above the add-on items on the booking details step. Customers only see this section when the selected event has add-ons for sale. Leave a field empty to hide it. You can use [Company Name] and [Company Group Name] as placeholders.</info-hint>
        <div class="row">
          <div class="col">
            <base-input label="Add-on section header" placeholder="e.g. Add ons" maxlength="255" v-model="selectedBss.addons_title">
            </base-input>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <base-textarea label="Add-on section description" v-model="selectedBss.addons_subtext" :maxlength="500"
                           placeholder="e.g. Would you like to upgrade your experience by adding some merchandise?" />
          </div>
        </div>
      </collapsible-section>

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>

    <!-- Customer info -->
    <div v-if="activeSection === 'customer-info'">
      <collapsible-section title="Standard fields" icon="tim-icons icon-single-02">
        <info-hint class="mt-0">Choose which details customers provide on the customer info step. Collected values are saved to the customer's profile.</info-hint>
        <div class="builtin-field-row">
          <div class="builtin-field-row__info">
            <div class="builtin-field-row__label text-white">Name</div>
            <div class="builtin-field-row__meta">First and last name</div>
          </div>
          <span class="builtin-field-row__locked">Always required</span>
        </div>
        <div class="builtin-field-row">
          <div class="builtin-field-row__info">
            <div class="builtin-field-row__label text-white">Email</div>
            <div class="builtin-field-row__meta">Used for booking confirmation</div>
          </div>
          <span class="builtin-field-row__locked">Always required</span>
        </div>
        <div class="builtin-field-row">
          <div class="builtin-field-row__info">
            <div class="builtin-field-row__label text-white">Phone</div>
            <div class="builtin-field-row__meta" v-if="selectedBss.phone_field_mode === 'hidden'">
              Hidden phone numbers are unavailable for SMS reminders and staff callbacks
            </div>
          </div>
          <segmented-toggle size="sm" variant="pills" v-model="selectedBss.phone_field_mode" :options="fieldModeOptions" />
        </div>
        <div class="builtin-field-row">
          <div class="builtin-field-row__info">
            <div class="builtin-field-row__label text-white">Address</div>
            <badge-dropdown class="builtin-field-row__scope" prefix="Collects"
                            :value="addressScope" :options="addressScopeOptions" @input="setAddressScope" />
          </div>
          <segmented-toggle size="sm" variant="pills" :value="addressRowMode" :options="fieldModeOptions" @input="setAddressRowMode" />
        </div>
      </collapsible-section>

      <collapsible-section title="Custom fields" icon="tim-icons icon-notes">
        <!-- Shared with PaymentPageEditor — CustomFieldLinkCards renders
             the draggable field cards, add-select, and both empty states.
             Persistence stays immediate here (events proxy straight to the
             existing activate/deactivate/behavior emits). -->
        <custom-field-link-cards
          :items="draggableCustomFields"
          :addable="inactiveCustomFields"
          :toggles="cfToggles"
          remove-tooltip="Remove from customer info"
          empty-title="No custom fields added"
          empty-linked-hint="Add fields from your library to collect extra details on the customer info step."
          @add="onCfAdd"
          @remove="onCfRemove"
          @toggle="onCfToggle"
          @reorder="onCfReorder"
        />
      </collapsible-section>

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>

    <!-- Checkout & payment -->
    <div v-if="activeSection === 'checkout'">
      <collapsible-section title="Promo codes" icon="tim-icons icon-tag">
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_promo_code_field"  />
            <label> &nbsp; Show promo code field</label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_promo_code_field">
          <div class="col">
            <base-input label="Promo code field placeholder text" placeholder="Promo code" v-model="selectedBss.promo_code_placeholder_text">
            </base-input>
          </div>
        </div>
        <div class="row mb-3" v-if="selectedBss.show_promo_code_field">
          <div class="col">
            <label class="text-white d-block">Show the promo code field on</label>
            <segmented-toggle size="sm" variant="pills"
                              v-model="selectedBss.promo_code_field_position"
                              :options="promoFieldPositionOptions" />
          </div>
        </div>
        <div class="row" v-if="selectedBss.show_promo_code_field">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_custom_promo_code_error_message"  />
            <label> &nbsp; Show custom error message for invalid promos</label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_custom_promo_code_error_message">
          <div class="col">
            <base-input label="Invalid promo code error message" placeholder="Promo code invalid" v-model="selectedBss.promo_code_error_message">
            </base-input>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Event upsell" icon="tim-icons icon-bag-16" :default-open="false">
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.show_upsell_section"  />
            <label class="text-white"> &nbsp; Suggest other events at checkout
              <el-popover trigger="hover" placement="right" width="320" popper-class="otc-pop">
                <div>
                  <div class="popover-body">
                    Once a customer has an event in the cart, the order summary lists up to three other events on this template with a bookable time on the same day, nearest to the booked time first. Book now opens the ticket step for that event.
                  </div>
                </div>
                <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
              </el-popover>
            </label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_upsell_section">
          <div class="col-lg-6">
            <base-input label="Section title" placeholder="Add another event?" v-model="selectedBss.upsell_title" :maxlength="255">
            </base-input>
          </div>
        </div>
        <div class="row" v-if="selectedBss.show_upsell_section">
          <div class="col">
            <base-input label="Section text">
              <el-input v-model="selectedBss.upsell_subtext" type="textarea" :rows="2" :maxlength="500"
                        placeholder="Other events available around your booking time."></el-input>
            </base-input>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_upsell_section">
          <div class="col">
            <label>Position</label>
            <div class="layout-picker mb-3">
              <div
                v-for="pos in upsellPositions"
                :key="'up-' + pos.id"
                class="layout-option"
                :class="{ active: (selectedBss.upsell_position || 'above_form') === pos.id }"
                @click="selectedBss.upsell_position = pos.id"
              >
                <!-- Mini page: form column on the left, order summary on the right, upsell card highlighted -->
                <div class="layout-option__preview upsell-pos-preview">
                  <div class="upsell-pos-col upsell-pos-col--main">
                    <div v-if="pos.id === 'above_form'" class="upsell-pos-block upsell-pos-block--upsell"></div>
                    <div class="upsell-pos-block"></div>
                    <div v-if="pos.id === 'below_form'" class="upsell-pos-block upsell-pos-block--upsell"></div>
                  </div>
                  <div class="upsell-pos-col">
                    <div class="upsell-pos-block"></div>
                    <div v-if="pos.id === 'below_cart'" class="upsell-pos-block upsell-pos-block--upsell"></div>
                    <div v-else class="upsell-pos-block upsell-pos-block--empty"></div>
                  </div>
                </div>
                <span class="layout-option__label">{{ pos.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.show_upsell_section">
          <div class="col-lg-6">
            <label>
              <div>Discount promo code
                <el-popover trigger="hover" placement="right" width="320" popper-class="otc-pop">
                  <div>
                    <div class="popover-body">
                      Optional. This code is applied automatically when a customer adds a suggested event, and removed again if the cart stops qualifying. Build the offer as a normal promo code first, for example a Buy X Get Y rule that discounts a second event. The code is visible to anyone using the booking site, so only link a code whose rules require the second event.
                    </div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input>
              <el-select
                v-model="selectedBss.upsell_promo_code_id"
                class="select-primary"
                clearable
                filterable
                placeholder="No discount"
              >
                <el-option
                  v-for="p in upsellPromoOptions"
                  class="select-primary"
                  :label="p.name"
                  :value="p.id"
                  :key="'UP' + p.id"
                ></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row" v-if="selectedBss.show_upsell_section && selectedBss.upsell_promo_code_id">
          <div class="col-lg-6">
            <base-input label="Discount badge text" placeholder="Save on a second event" v-model="selectedBss.upsell_badge_text" :maxlength="100">
            </base-input>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Deposits" icon="tim-icons icon-coins" :default-open="false">
        <info-hint style="width: 100%">
          Controls how the deposit choice appears at checkout. Customers only see deposit options when <strong>deposits are enabled for the event or booking slot</strong>.
          <strong>Checkbox</strong> shows a single "pay deposit" checkbox (classic), <strong>buttons</strong> shows "pay in full" and "pay deposit" side by side,
          and <strong>stacked cards</strong> shows two full-width options with amount breakdowns.
        </info-hint>
        <div class="row">
          <div class="col-lg-6">
            <label>Deposit options layout</label>
            <base-input>
              <el-select
                v-model="selectedBss.deposit_layout_type"
                class="select-primary"
              >
                <el-option class="select-primary" label="Checkbox" value="checkbox"></el-option>
                <el-option class="select-primary" label="Buttons" value="buttons"></el-option>
                <el-option class="select-primary" label="Stacked cards" value="cards"></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.enable_deposit_text"  />
            <label> &nbsp; Show custom deposit description</label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.enable_deposit_text">
          <div class="col">
            <label>Deposit description</label>
            <el-input class="deposit-text-input" v-model="selectedBss.deposit_text" type="textarea" :rows="3" :maxlength="500" show-word-limit
                      placeholder="e.g. When leaving a deposit, we will charge you for the total number of players in your party prior to the start of your experience."></el-input>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Cart & timeouts" icon="tim-icons icon-cart" :default-open="false">
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.clear_stale_carts"  />
            <label> &nbsp; "In Cart" expiration</label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.clear_stale_carts">
          <div class="col">
            <label>Cart timeout</label>
            <div class="row">
              <div class="col-lg-3">
                <base-input v-model="selectedBss.cart_timeout_value" type="number"></base-input>
              </div>
              <div class="col-lg-4">
                <base-input>
                  <el-select
                    v-model="selectedBss.cart_timeout_period"
                    class="select-primary"
                    value-key="id"
                  >
                    <el-option
                      v-for="(tp, index) in timeoutPeriods"
                      class="select-primary"
                      :label="tp.label"
                      :value="{id: tp.id, label: tp.label}"
                      :key="'L' + index"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.unblock_incomplete_bookings"  />
            <label> &nbsp; Unblock bookings with incomplete payments</label>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.unblock_incomplete_bookings">
          <div class="col">
            <label>Incomplete booking timeout</label>
            <div class="row">
              <div class="col-lg-3">
                <base-input v-model="selectedBss.timeout_value" type="number"></base-input>
              </div>
              <div class="col-lg-4">
                <base-input>
                  <el-select
                    v-model="selectedBss.timeout_period"
                    class="select-primary"
                    value-key="id"
                  >
                    <el-option
                      v-for="(tp, index) in timeoutPeriods"
                      class="select-primary"
                      :label="tp.label"
                      :value="{id: tp.id, label: tp.label}"
                      :key="'M' + index"
                    ></el-option>
                  </el-select>
                </base-input>
              </div>
            </div>
          </div>
        </div>
      </collapsible-section>

      <!-- Add another booking button - commented out, not ready yet
      <collapsible-section title="Add another booking button" icon="tim-icons icon-simple-add" :default-open="false">
        <div class="row">
          <div class="col-lg-6">
            <label>
              <div>Button behavior
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">
                      Controls what happens with the "Add another booking" button
                      that appears on the checkout and confirmation steps.

                      Show - always show, takes the customer back to step 1
                      Hide - hide the button entirely
                      Redirect to URL - button links to a custom URL (e.g. your main booking page)
                    </div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input>
              <el-select
                v-model="selectedBss.add_another_booking_behavior"
                class="select-primary"
                placeholder="Show"
              >
                <el-option class="select-primary" label="Show" value="show"></el-option>
                <el-option class="select-primary" label="Hide" value="hide"></el-option>
                <el-option class="select-primary" label="Redirect to URL" value="custom_url"></el-option>
              </el-select>
            </base-input>
          </div>
        </div>
        <div class="row mt-2" v-if="selectedBss.add_another_booking_behavior === 'custom_url'">
          <div class="col-lg-6">
            <label>Redirect URL</label>
            <base-input type="text" placeholder="https://example.com/book" v-model="selectedBss.add_another_booking_url"></base-input>
          </div>
        </div>
      </collapsible-section>
      -->

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>

    <!-- Confirmation -->
    <div v-if="activeSection === 'confirmation'">
      <collapsible-section title="Messages" icon="tim-icons icon-chat-33">
        <div class="row">
          <div class="col">
            <label>
              <div>Confirmation page message
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">Create a custom message your customers <br/>will see when they complete a booking.<br/>
                      This field supports dynamic variables <br/><code>[Company Name]</code> and <code>[Company Group Name]</code>
                    </div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input type="text" placeholder="Thank you for booking with us" v-model="selectedBss.confirmation_message"></base-input>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-8">
            <label>
              <div>Insufficient resource error message
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">This message will appear on the booking site <br>
                      when the customer attempts to make a booking that <br>
                      you do not have resources to cover</div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input type="text" placeholder="Your booking cannot be completed" v-model="selectedBss.insufficient_resource_message"></base-input>
          </div>
        </div>
      </collapsible-section>

      <collapsible-section title="Redirect & links" icon="tim-icons icon-link-72" :default-open="false">
        <div class="row">
          <div class="col-md-12 col-lg-6 col-sm-12 col-12">
            <label>
              <div>Redirect link
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">This link will appear on the last page of the customer booking experience.<br/>
                      Use it to redirect customer to your website or social media. <br/>
                      It will go to https://offthecouch.io by default</div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input :error="errs.redirect_url" type="text" placeholder="http://example.com" v-model="selectedBss.redirect_url"></base-input>
          </div>
          <div class="col-md-12 col-lg-4 col-sm-12 col-12" v-if="selectedBss.auto_redirect">
            <label>
              <div>Redirect delay (seconds)
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">The amount of time before the user is automatically redirected to the specified location</div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input placeholder="15s" name="delay">
              <el-input-number v-model="selectedBss.redirect_delay" :min="1" :max="1000"/>
            </base-input>
          </div>
          <div class="col-md-12 col-lg-6 col-sm-12 col-12" v-if="!selectedBss.auto_redirect">
            <label>
              <div>Redirect button text
                <el-popover trigger="hover" placement="right">
                  <div>
                    <div class="popover-body">This is the label for the button that will redirect the user <br/> to the desired location when a booking is completed</div>
                  </div>
                  <i slot="reference" style="color: #1d8cf8" class="tim-icons el-icon-info"></i>
                </el-popover>
              </div>
            </label>
            <base-input :error="errs.redirect_button_text" type="text" placeholder="Back" v-model="selectedBss.redirect_button_text"></base-input>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.auto_redirect"  />
            <label> &nbsp; Automatically redirect the user when a booking has been completed</label>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-switch active-color="#e14eca"
                       v-model="selectedBss.display_waiver_link"  />
            <label> &nbsp; Include waiver link on booking confirmation</label>
          </div>
        </div>
      </collapsible-section>

      <div class="row mt-3">
        <div class="col">
          <base-button type="primary" v-on:click="$emit('save')">Save changes</base-button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import CollapsibleSection from '../shared/CollapsibleSection.vue'
import EditorSectionNav from '@/components/PaymentPages/EditorSectionNav.vue'
import BadgeDropdown from '@/components/BadgeDropdown.vue'
import ColorField from '@/components/PaymentPages/ColorField.vue'
import {ColorPicker, Select, Option, Switch, Popover, Input, InputNumber, DatePicker, Tooltip, Dropdown, DropdownItem, DropdownMenu} from 'element-ui';
import {Badge} from 'src/components';
import { BIcon, BIconCardHeading, BIconCardText, BIconTag, BIconLayoutThreeColumns } from 'bootstrap-vue';
import draggable from 'vuedraggable';

export default {
  name: 'ContentTab',
  components: {
    CollapsibleSection,
    EditorSectionNav,
    BadgeDropdown,
    ColorField,
    Badge,
    BIcon,
    BIconCardHeading,
    BIconCardText,
    BIconTag,
    BIconLayoutThreeColumns,
    draggable,
    [ColorPicker.name]: ColorPicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    [Popover.name]: Popover,
    [Input.name]: Input,
    [InputNumber.name]: InputNumber,
    [DatePicker.name]: DatePicker,
    [Tooltip.name]: Tooltip,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  props: {
    selectedBss: {
      type: [Object, String],
      required: true
    },
    games: {
      type: Array,
      default: () => []
    },
    promos: {
      type: Array,
      default: () => []
    },
    allGroupGames: {
      type: Array,
      default: () => []
    },
    paymentSettings: {
      type: Array,
      default: () => []
    },
    group: {
      type: Object,
      default: () => ({})
    },
    customFields: {
      type: Array,
      default: () => []
    },
    isCreateMode: {
      type: Boolean,
      default: false
    },
    defaultDateOptions: {
      type: Array,
      default: () => []
    },
    timeoutPeriods: {
      type: Array,
      default: () => []
    },
    dateFormatCal: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    errs: {
      type: Object,
      default: () => ({})
    },
    fonts: {
      type: [Array, String],
      default: () => []
    },
    orderedFonts: {
      type: Array,
      default: () => []
    },
    fitOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeSection: 'general',
      sortableGames: [],
      draggableCustomFields: [],
      layoutTypes: [
        { id: 1, name: 'cards', label: 'Card grid' },
        { id: 2, name: 'list', label: 'List board' },
        // Calendar view is not ready for release yet — hidden as an option for now.
        // { id: 3, name: 'calendar', label: 'Calendar view' }
      ],
      listImageSizes: [
        { id: 1, label: 'Small', thumbWidth: 10, thumbHeight: 14 },
        { id: 2, label: 'Medium', thumbWidth: 16, thumbHeight: 18 },
        { id: 3, label: 'Large', thumbWidth: 22, thumbHeight: 22 },
        { id: 4, label: 'Extra large', thumbWidth: 28, thumbHeight: 26 }
      ],
      listImagePositions: [
        { id: 1, label: 'Left' },
        { id: 2, label: 'Right' },
        { id: 3, label: 'Top' }
      ],
      fieldModeOptions: [
        { value: 'hidden', label: 'Hidden' },
        { value: 'optional', label: 'Optional' },
        { value: 'required', label: 'Required' }
      ],
      promoFieldPositionOptions: [
        { value: 'all_steps', label: 'Every checkout step' },
        { value: 'final_step', label: 'Final step only' }
      ],
      addressScope: 'full',
      addressScopeOptions: [
        { value: 'full', label: 'Full address' },
        { value: 'zip', label: 'Zip/postal code only' }
      ],
      sections: [
        { id: 'general',        label: 'General settings' },
        { id: 'events',         label: 'Event selection' },
        { id: 'event-details',  label: 'Event details' },
        { id: 'customer-info',  label: 'Customer info' },
        { id: 'checkout',       label: 'Checkout & payment' },
        { id: 'confirmation',   label: 'Confirmation' }
      ]
    }
  },
  computed: {
    upsellPositions() {
      return [
        { id: 'above_form', label: 'Above the form' },
        { id: 'below_form', label: 'Below the form' },
        { id: 'below_cart', label: 'Below the summary' }
      ]
    },
    // Live promo codes, plus the linked one when it has since been archived
    upsellPromoOptions() {
      const options = this.promos.map(p => ({ id: p.id, name: p.name }))
      const linkedId = this.selectedBss && this.selectedBss.upsell_promo_code_id
      if (linkedId && !options.some(o => o.id === linkedId)) {
        options.unshift({ id: linkedId, name: (this.selectedBss.upsell_promo_code_name || 'Promo ' + linkedId) + ' (archived)' })
      }
      return options
    },
    triggerIconOptions() {
      return [
        { name: 'book', value: 'book' },
        { name: 'card text', value: 'card-text' },
        { name: 'chat', value: 'chat' },
        { name: 'eye', value: 'eye' },
        { name: 'info circle', value: 'info-circle' },
        { name: 'info square', value: 'info-square' },
        { name: 'journal text', value: 'journal-text' },
        { name: 'lightbulb', value: 'lightbulb' },
        { name: 'list', value: 'list-ul' },
        { name: 'plus circle', value: 'plus-circle' },
        { name: 'question circle', value: 'question-circle' },
        { name: 'search', value: 'search' },
        { name: 'three dots', value: 'three-dots' }
      ]
    },
    triggerPositionOptions() {
      return [
        { label: 'Top left', value: 'top-left' },
        { label: 'Top right', value: 'top-right' },
        { label: 'Bottom left', value: 'bottom-left' },
        { label: 'Bottom right', value: 'bottom-right' }
      ]
    },
    availableGames() {
      const activeGameIds = new Set(this.games.filter(g => g.is_active == 1).map(g => g.game_id))
      return this.allGroupGames.filter(g => !g.archived && !activeGameIds.has(g.id))
    },
    activeCustomFields() {
      return this.customFields.filter(f => f.active)
    },
    cfToggles() {
      // type arrives as {id} here (vs the INT code on payment pages);
      // CustomFieldLinkCards normalizes display, appliesTo gets the raw item.
      const typeId = (f) => Number(f.type && f.type.id != null ? f.type.id : f.type)
      return [
        { key: 'required', label: 'Required', tooltip: 'Make field required' },
        { key: 'interaction_required', label: 'Requires user interaction', appliesTo: (f) => typeId(f) === 1 },
        { key: 'add_alert', label: 'Creates alert', tooltip: 'Show alert on booking calendar when filled out' },
      ]
    },
    inactiveCustomFields() {
      return this.customFields.filter(f => !f.active)
    },
    // The single "Address" row drives two ENUM columns; which one depends on scope
    addressRowMode() {
      return this.addressScope === 'zip'
        ? (this.selectedBss.zip_field_mode || 'hidden')
        : (this.selectedBss.address_field_mode || 'hidden')
    }
  },
  watch: {
    'selectedBss.address_field_mode': {
      handler() { this.syncAddressScope() },
      immediate: true
    },
    'selectedBss.zip_field_mode'() { this.syncAddressScope() },
    activeSection(val) {
      const idx = this.sections.findIndex(s => s.id === val)
      this.$emit('section-changed', idx)
    },
    games: {
      handler(val) {
        this.sortableGames = val.filter(g => g.is_active == 1).sort((a, b) => a.position - b.position)
      },
      immediate: true,
      deep: true
    },
    activeCustomFields: {
      handler(val) {
        // Sort by position so a fresh fetch (or any new array) lands in display order.
        // No deep watch — mutating `position` after a drag would otherwise reset the order.
        this.draggableCustomFields = [...val].sort((a, b) => (a.position || 0) - (b.position || 0))
      },
      immediate: true
    }
  },
  methods: {
    setSection(id) {
      this.activeSection = id
    },
    // Keep the scope picker in sync with whichever column is active (e.g. on load).
    // When both are hidden, keep the user's last choice.
    syncAddressScope() {
      if (this.selectedBss.address_field_mode && this.selectedBss.address_field_mode !== 'hidden') {
        this.addressScope = 'full'
      } else if (this.selectedBss.zip_field_mode && this.selectedBss.zip_field_mode !== 'hidden') {
        this.addressScope = 'zip'
      }
    },
    setAddressRowMode(mode) {
      if (this.addressScope === 'zip') {
        this.selectedBss.zip_field_mode = mode
        this.selectedBss.address_field_mode = 'hidden'
      } else {
        this.selectedBss.address_field_mode = mode
        this.selectedBss.zip_field_mode = 'hidden'
      }
    },
    setAddressScope(scope) {
      const mode = this.addressRowMode
      this.addressScope = scope
      this.setAddressRowMode(mode)
    },
    // Defaults mirror initializeNewTemplate in BookingSiteTemplateEditor
    resetPaletteColors() {
      this.selectedBss.background_color = '#1e1e2f'
      this.selectedBss.text_color = '#ffffff'
      this.selectedBss.card_color = '#27293d'
      this.selectedBss.text_color_card = '#ffffff'
      this.selectedBss.link_color = '#1d8cf8'
      this.selectedBss.button_color = '#e14eca'
      this.selectedBss.input_border_color = '#7d7d7d99'
    },
    onDragEnd() {
      this.sortableGames.forEach((game, i) => {
        game.position = i
      })
      this.$emit('update-site-content', 'update_order', this.sortableGames[0])
    },
    addGame(groupGame) {
      const existingLink = this.games.find(g => g.game_id === groupGame.id && g.is_active != 1)
      if (existingLink) {
        this.$emit('update-site-content', 'add_to_site', existingLink)
      } else {
        this.$emit('update-site-content', 'add_to_site', {
          game_id: groupGame.id,
          name: groupGame.name,
          is_active: 0,
          has_unique_link: 0
        })
      }
    },
    removeGame(game) {
      this.$emit('update-site-content', 'remove_from_site', game)
    },
    activateField(field) {
      this.$emit('edit-custom-field', 'activate', field)
    },
    // ─── CustomFieldLinkCards adapters ───────────────────────────────
    onCfAdd(fieldId) {
      const f = this.inactiveCustomFields.find((x) => x.id === fieldId)
      if (f) this.activateField(f)
    },
    onCfRemove(idx) {
      const f = this.draggableCustomFields[idx]
      if (f) this.deactivateField(f)
    },
    onCfToggle(idx, key, value) {
      const f = this.draggableCustomFields[idx]
      if (f) this.updateBehavior(f, key, value)
    },
    onCfReorder(items) {
      // Component already renumbered .position on each item.
      this.$emit('update-custom-field-order', items)
    },
    deactivateField(field) {
      this.$emit('edit-custom-field', 'deactivate', field)
    },
    updateBehavior(field, key, value) {
      field[key] = value
      this.$emit('edit-custom-field-behavior', field)
    },
    getCustomFieldTypeName(typeId) {
      const map = { 1: 'CHECKBOX', 2: 'INPUT FIELD', 3: 'DROPDOWN' }
      return map[typeId] || 'FIELD'
    },
    getCustomFieldTypeIcon(typeId) {
      const map = {
        1: 'far fa-check-square',
        2: 'tim-icons icon-pencil',
        3: 'tim-icons icon-bullet-list-67',
      }
      return map[typeId] || 'tim-icons icon-bullet-list-67'
    },
    onCustomFieldDragEnd() {
      // Superseded by CustomFieldLinkCards' reorder event (onCfReorder).
      this.$emit('update-custom-field-order', this.draggableCustomFields)
    }
  }
}
</script>

<style>
.content-toolbar-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-size: 13px;
  color: #fff;
  background: #e14eca;
  border: 1px solid #e14eca;
  border-radius: 6px;
  cursor: pointer;
  height: 34px;
}
.content-toolbar-btn:hover {
  background: #c238ab;
  border-color: #c238ab;
  color: #fff;
}
.add-btn-select .el-input__inner {
  background: #e14eca;
  border-color: #e14eca;
  color: #fff;
  font-size: 13px;
  border-radius: 6px;
  cursor: pointer;
}
.add-btn-select .el-input__inner::placeholder {
  color: #fff;
}
.add-btn-select .el-input__inner:hover,
.add-btn-select .el-input__inner:focus {
  background: #c238ab;
  border-color: #c238ab;
}
.add-btn-select .el-input.is-focus .el-input__inner {
  border-color: #c238ab;
}
.add-btn-select .el-input__suffix .el-input__icon {
  color: #fff;
}
.deposit-text-input .el-textarea__inner {
  background-color: rgba(30, 30, 47, 0.6);
  border-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}
.deposit-text-input .el-textarea__inner:focus {
  border-color: #e14eca;
}
.deposit-text-input .el-textarea__inner::placeholder {
  color: rgba(255, 255, 255, 0.4);
  font-size: 12px;
}
.deposit-text-input .el-input__count {
  background: transparent;
  color: rgba(255, 255, 255, 0.4);
}
.white-content .deposit-text-input .el-textarea__inner {
  background-color: rgba(0, 0, 0, 0.02);
  border-color: rgba(0, 0, 0, 0.15);
  color: rgba(0, 0, 0, 0.85);
}
.white-content .deposit-text-input .el-textarea__inner::placeholder {
  color: rgba(0, 0, 0, 0.35);
}
.white-content .deposit-text-input .el-input__count {
  color: rgba(0, 0, 0, 0.4);
}
</style>

<style scoped>
.section-divider {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 16px 0;
}
.switch-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.switch-row > label {
  margin-bottom: 0;
  flex: 1;
  min-width: 0;
}
.switch-row ::v-deep .el-switch {
  flex-shrink: 0;
}

.game-info-trigger-config {
  margin-left: 44px;
  margin-top: 8px;
  padding-left: 12px;
  border-left: 2px solid rgba(125, 125, 125, 0.25);
}
@media (max-width: 767px) {
  .game-info-trigger-config {
    margin-left: 8px;
  }
}
.game-info-trigger-config ::v-deep .el-input__count,
.game-info-trigger-config ::v-deep .el-input__count-inner {
  background: transparent;
  color: rgba(125, 125, 125, 0.8);
  font-size: 0.75rem;
}
.ct-split {
  display: flex;
  align-items: stretch;
  min-height: 480px;
}
.ct-nav {
  width: 200px;
  flex-shrink: 0;
  padding-right: 16px;
}
.ct-content {
  flex: 1;
  min-width: 0;
  padding-left: 24px;
}
@media (max-width: 991px) {
  .ct-split { flex-direction: column; }
  .ct-nav {
    width: 100%;
    padding-right: 0;
    padding-bottom: 12px;
    margin-bottom: 16px;
  }
  .ct-content { padding-left: 0; }
}

.section-label {
  color: #fff;
}

/* Built-in customer info fields */
.builtin-field-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 10px 12px;
  border-radius: 0.375rem;
  transition: background 0.15s ease;
}
.builtin-field-row:hover {
  background: rgba(125, 125, 125, 0.06);
}
.builtin-field-row + .builtin-field-row {
  margin-top: 4px;
}
.builtin-field-row__info {
  min-width: 0;
}
.builtin-field-row__label {
  font-size: 0.875rem;
  font-weight: 600;
}
.builtin-field-row__meta {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  margin-top: 4px;
}
.builtin-field-row__locked {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
  white-space: nowrap;
}
/* Field-mode toggles use the shared segmented-toggle variant="pills" — styles live in the component */
.builtin-field-row .toggle-group {
  flex-shrink: 0;
}
.builtin-field-row__scope {
  margin-top: 4px;
}

/* Custom field cards (matches WaiverTemplate field-card pattern) */
.cf-list {
  display: flex;
  flex-direction: column;
}
.field-card + .field-card {
  margin-top: 8px;
}
.field-card {
  container-type: inline-size;
  border-radius: 0.375rem;
  padding: 10px 12px;
  transition: background 0.15s ease;
}
.field-card:hover {
  background: rgba(125, 125, 125, 0.06);
}
.field-card--chosen {
  background: rgba(225, 78, 202, 0.08);
}
.field-card--ghost {
  opacity: 0.35;
  background: rgba(225, 78, 202, 0.05);
}
.field-card__body {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: nowrap;
  min-width: 0;
}
.field-card__drag-handle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.35);
  cursor: grab;
  flex-shrink: 0;
  padding: 4px;
  margin: -4px;
  transition: color 0.15s ease;
  touch-action: none;
}
.field-card__drag-handle:active {
  cursor: grabbing;
}
.field-card:hover .field-card__drag-handle {
  color: rgba(255, 255, 255, 0.7);
}
.field-card__type-icon {
  font-size: 1.1em;
  color: #e14eca;
  width: 28px;
  text-align: center;
  flex-shrink: 0;
}
.field-card__info {
  flex: 1 1 0;
  min-width: 90px;
}
.field-card__label {
  font-size: clamp(0.7rem, 2.4cqw, 0.9rem);
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.field-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-top: 3px;
  font-size: 11px;
}
.field-card__type-name {
  text-transform: uppercase;
  letter-spacing: 0.04em;
  font-weight: 600;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.55);
}
.field-card__actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.field-card__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
}
.field-card__toggle-label {
  font-size: clamp(7px, 1.5cqw, 10px);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
  white-space: nowrap;
}
.field-card__saving {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 4px;
}
.field-card__remove-btn {
  min-width: 32px;
  min-height: 32px;
  padding: 6px;
  margin-left: 4px;
}
.cf-add-row {
  margin-top: 10px;
}
.add-custom-field-select {
  width: 240px;
  max-width: 100%;
}
.add-custom-field-select ::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
  border: 1px dashed rgba(225, 78, 202, 0.4);
  background: rgba(225, 78, 202, 0.03);
  color: rgba(225, 78, 202, 0.9);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
  padding-left: 14px;
  transition: background 0.15s ease, border-color 0.15s ease;
  cursor: pointer;
}
.add-custom-field-select ::v-deep .el-input__inner:hover {
  border-color: rgba(225, 78, 202, 0.7);
  background: rgba(225, 78, 202, 0.08);
}
.add-custom-field-select ::v-deep .el-input--suffix.is-focus .el-input__inner,
.add-custom-field-select ::v-deep .el-input__inner:focus {
  border-style: solid;
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.1);
  color: #e14eca;
}
.add-custom-field-select ::v-deep .el-input__inner::placeholder {
  color: rgba(225, 78, 202, 0.9);
  font-weight: 600;
}
.add-custom-field-select ::v-deep .el-input__icon {
  color: rgba(225, 78, 202, 0.7);
  line-height: 36px;
}
.add-custom-field-select__option-type {
  float: right;
  font-size: 10px;
  text-transform: uppercase;
  color: rgba(125, 125, 125, 0.8);
  letter-spacing: 0.04em;
  margin-left: 12px;
}
@container (max-width: 800px) {
  .field-card__body { gap: 10px; }
  .field-card__actions { gap: 8px; }
  .field-card__toggle { gap: 5px; }
}
@container (max-width: 480px) {
  .field-card__toggle {
    flex-direction: column;
    align-items: center;
    gap: 3px;
  }
  .field-card__toggle-label {
    font-size: clamp(7px, 1cqw, 9px);
    line-height: 1.1;
  }
  .field-card__actions { gap: 10px; }
}
@media (max-width: 575.98px) {
  .builtin-field-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
  }
  .field-card { padding: 8px 10px; }
  .field-card__type-icon { display: none; }
  .field-card__drag-handle { font-size: 12px; }
  .field-card__actions { gap: 6px; }
  .field-card__remove-btn { min-width: 28px; min-height: 28px; padding: 4px; margin-left: 0; }
  .field-card__toggle-label { display: none; }
  .field-card__toggle { flex-direction: row; }
  .add-custom-field-select { width: 100%; max-width: none; }
}

/* Light mode overrides */
.white-content .builtin-field-row__meta,
.white-content .builtin-field-row__locked {
  color: rgba(0, 0, 0, 0.7);
}
.white-content .builtin-field-row:hover {
  background: rgba(0, 0, 0, 0.03);
}
.white-content .builtin-field-row__label.text-white {
  color: rgba(0, 0, 0, 0.85) !important;
}
.white-content .field-card:hover {
  background: rgba(0, 0, 0, 0.03);
}
.white-content .field-card__label.text-white {
  color: rgba(0, 0, 0, 0.85) !important;
}
.white-content .field-card__drag-handle { color: rgba(0, 0, 0, 0.3); }
.white-content .field-card:hover .field-card__drag-handle { color: rgba(0, 0, 0, 0.6); }
.white-content .field-card__type-icon { color: #cc5fad; }
.white-content .field-card__meta,
.white-content .field-card__type-name { color: rgba(0, 0, 0, 0.6); }
.white-content .field-card__toggle-label { color: rgba(0, 0, 0, 0.7); }
.white-content .field-card__saving { color: rgba(0, 0, 0, 0.4); }
.white-content .add-custom-field-select .el-input__inner {
  border-color: rgba(204, 95, 173, 0.5);
  background: rgba(204, 95, 173, 0.05);
  color: #b04a93;
}
.white-content .add-custom-field-select .el-input__inner::placeholder {
  color: #b04a93;
}
.white-content .add-custom-field-select__option-type { color: rgba(0, 0, 0, 0.55); }
.white-content .section-divider {
  border-top-color: rgba(0, 0, 0, 0.08);
}
.white-content .section-label {
  color: #344675;
}
.white-content .empty-state-text {
  color: #344675;
}

/* Layout picker */
.layout-picker {
  display: flex;
  gap: 12px;
}
.layout-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  cursor: pointer;
  transition: all 0.2s;
  min-width: 100px;
}
.layout-option:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
}
.layout-option.active {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.1);
}
.layout-option__preview {
  width: 64px;
  height: 48px;
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.05);
}
.layout-preview-cards {
  flex-wrap: wrap;
  align-content: flex-start;
}
.layout-preview-cards .mini-card {
  width: 17px;
  height: 20px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
}
.layout-preview-list {
  flex-direction: column;
  justify-content: center;
  gap: 3px;
}
.layout-preview-list .mini-row {
  width: 100%;
  height: 10px;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
}
.layout-preview-calendar {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1px;
  align-content: flex-start;
}
.layout-preview-calendar .mini-cal-cell {
  width: 100%;
  height: 7px;
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
}
.layout-option__label {
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
}
.layout-option.active .layout-option__label {
  color: #e14eca;
}

/* Upsell position picker thumbnails (layout-option family) */
.upsell-pos-preview {
  gap: 3px;
}
.upsell-pos-col {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.upsell-pos-col--main {
  flex: 3;
}
.upsell-pos-block {
  flex: 1;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.2);
}
.upsell-pos-block--upsell {
  flex: 0 0 11px;
  background: #e14eca;
}
.upsell-pos-block--empty {
  flex: 0 0 11px;
  background: transparent;
}
.white-content .upsell-pos-block {
  background: rgba(0, 0, 0, 0.15);
}
.white-content .upsell-pos-block--upsell {
  background: #e14eca;
}
.white-content .upsell-pos-block--empty {
  background: transparent;
}

/* Layout picker light mode */
.white-content .layout-option {
  border-color: rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.02);
}
.white-content .layout-option:hover {
  border-color: rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.04);
}
.white-content .layout-option.active {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.08);
}
.white-content .layout-option__preview {
  background: rgba(0, 0, 0, 0.04);
}
.white-content .layout-preview-cards .mini-card,
.white-content .layout-preview-list .mini-row,
.white-content .layout-preview-calendar .mini-cal-cell {
  background: rgba(0, 0, 0, 0.15);
}
.white-content .layout-option__label {
  color: rgba(0, 0, 0, 0.6);
}
.white-content .layout-option.active .layout-option__label {
  color: #e14eca;
}

/* Image size picker */
.image-size-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 8px;
  display: block;
}
.image-size-picker {
  display: flex;
  gap: 10px;
}
.image-size-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  cursor: pointer;
  transition: all 0.2s;
  min-width: 80px;
}
.image-size-option:hover {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.06);
}
.image-size-option.active {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.1);
}
.image-size-option__preview {
  width: 56px;
  height: 32px;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 4px;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.05);
}
.size-thumb {
  border-radius: 2px;
  background: rgba(225, 78, 202, 0.35);
  flex-shrink: 0;
}
.size-lines {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
  min-width: 0;
}
.size-line {
  height: 3px;
  border-radius: 1px;
  background: rgba(255, 255, 255, 0.2);
  width: 100%;
}
.size-line.short {
  width: 60%;
}

/* Image size picker light mode */
.white-content .image-size-label {
  color: rgba(0, 0, 0, 0.5);
}
.white-content .image-size-option {
  border-color: rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.02);
}
.white-content .image-size-option:hover {
  border-color: rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.04);
}
.white-content .image-size-option.active {
  border-color: #e14eca;
  background: rgba(225, 78, 202, 0.08);
}
.white-content .image-size-option__preview {
  background: rgba(0, 0, 0, 0.04);
}
.white-content .size-thumb {
  background: rgba(225, 78, 202, 0.25);
}
.white-content .size-line {
  background: rgba(0, 0, 0, 0.15);
}
</style>
